import { createContext, useContext, useEffect, useState, useCallback } from "react";
import * as Api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [team, setTeam] = useState(null);
  const [isStaff, setIsStaff] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!Api.getToken()) { setUser(null); setTeam(null); setIsStaff(false); setLoading(false); return; }
    try {
      const d = await Api.getMe();
      setUser(d.user); setTeam(d.team);
      // best-effort staff flag — non-fatal if backend doesn't respond
      try { const f = await Api.getStaffFlag(); setIsStaff(!!f.is_staff); }
      catch { setIsStaff(false); }
    } catch (e) {
      Api.setToken(null);
      setUser(null); setTeam(null); setIsStaff(false);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  function loginAs(token, u, t) {
    Api.setToken(token);
    setUser(u); setTeam(t);
    // re-fetch staff flag on fresh login
    Api.getStaffFlag().then(f => setIsStaff(!!f.is_staff)).catch(() => setIsStaff(false));
  }
  function logout() {
    Api.setToken(null);
    setUser(null); setTeam(null); setIsStaff(false);
  }

  return (
    <AuthCtx.Provider value={{ user, team, isStaff, loading, refresh, loginAs, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const v = useContext(AuthCtx);
  if (!v) throw new Error("useAuth outside provider");
  return v;
}
